import 'css-chunksrc/client/common/preview/zipRenderer/styles.scss';export default {
  "node": "_node_1len5_1"
};